import { cache } from "react"
import directusServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

interface PostFacets {
  tagSlugs: string[]
  categorySlugs: string[]
}

/**
 * Returns the set of skill (tag) slugs and category slugs that appear in at
 * least one published post. Used to populate the work filter UI so that only
 * facets which can actually return results are shown.
 */
const getPostFilterFacets = cache(async (): Promise<PostFacets> => {
  try {
    const response = await directusServer.query(`
      query postFilterFacets {
        posts(
          filter: { status: { _eq: "published" } },
          limit: -1
        ) {
          skills(filter: { skills_id: { status: { _eq: "published" } } }) {
            skills_id { slug }
          }
          category(filter: { category_id: { status: { _eq: "published" } } }) {
            category_id { slug }
          }
        }
      }
    `)

    const posts = response?.posts ?? []
    const tagSlugs = new Set<string>()
    const categorySlugs = new Set<string>()

    for (const post of posts) {
      for (const skill of post?.skills ?? []) {
        const slug = skill?.skills_id?.slug
        if (slug) tagSlugs.add(slug)
      }
      for (const cat of post?.category ?? []) {
        const slug = cat?.category_id?.slug
        if (slug) categorySlugs.add(slug)
      }
    }

    return {
      tagSlugs: Array.from(tagSlugs),
      categorySlugs: Array.from(categorySlugs),
    }
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.error(error)
    return { tagSlugs: [], categorySlugs: [] }
  }
})

export default getPostFilterFacets
